import React, { PropTypes } from 'react';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

import Filter from '../Filter';

import styled from 'styled-components';

const NumericalRange = styled.section`
  .input-range {
    width: 80% !important;
    margin: 0 auto !important;
  }
  .input-range__slider{
    background: ${props => props.theme.color.secondary};
    border: 4px solid rgba(255,255,255,0.5);
  }

  .input-range__track{
    background: ${props => props.theme.color.base3};
    height: 0.15rem;
    .input-range__track--active{
      background: ${props => props.theme.color.secondary};
    }
  }

  .input-range__label--min, .input-range__label--max, .input-range__label--value{
    display: none;
  }
`;

const FilterContainer = styled.div`
  padding-top: 10px;
`;

const LabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const RangeLabelValue = styled.label`
  color: ${props => props.theme.color.secondary};
  padding: 0.6rem 0;
  min-width: 70px;
  text-align: center;
  background: ${props => props.theme.color.white};
  border: 1px solid ${props => props.theme.color.base3};
`

const NumericalRangeFilter = ({filter, action}) => {

  const handleRangeChange = (range) => {
    const value = range,
    label = `${range.min} - ${range.max}`;
    action({ label, value });
  };

  const value = {
    min: Number(filter.value.min),
    max: Number(filter.value.max)
  };

  const {minRange,maxRange} = filter.options;

  return (
    <NumericalRange>
      <FilterContainer>
        <InputRange
          maxValue={maxRange}
          minValue={minRange}
          value={value}
          onChange={handleRangeChange} />
        <LabelContainer>
          <RangeLabelValue>{value.min}</RangeLabelValue>
          <RangeLabelValue>{value.max}</RangeLabelValue>
        </LabelContainer>
      </FilterContainer>
    </NumericalRange>
  );
};

NumericalRangeFilter.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired
};

NumericalRangeFilter.getLabel = Filter.getLabel;

export default NumericalRangeFilter;



// WEBPACK FOOTER //
// ./src/components/filter/filters/numerical-range/NumericalRange.js